export default __webpack_public_path__ + "static/media/infra-6.5fadb423.webp";